import { render, staticRenderFns } from "./ProfileCorrection.vue?vue&type=template&id=e394220a&scoped=true&"
import script from "./ProfileCorrection.vue?vue&type=script&lang=js&"
export * from "./ProfileCorrection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCorrection.vue?vue&type=style&index=0&id=e394220a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e394220a",
  null
  
)

export default component.exports